<script>
import {DateUtil} from '@/utils/date.js'
import {PlannRoute} from '@/utils/planningRoute.js'
export default {
  data () {
    return {
      // 选择的时的集合
      hourList: [],
      // 选择的分的集合
      minuteList: [],
      // route和停留所信息
      routeStationInfo: [],
      // 被选中的route相关的所有信息
      selectedRouteStationInfo: [],
      // 时间校验标志位
      timeValidateFlag: false,
      // 出发地和终着地时间校验标志位
      startEndTimeValidateFlag: false,
      timeError: false,
      shiftTimeError: false
    }
  },
  props: {
    // 行归flag
    goBackFlag: { type: String, default: '0' },
    // 被选中的route相关的所有信息
    // selectedRouteStationInfo: []
    // 选择的routeID
    routeId: '',
    // 不同功能的标志位 0:便を登録 1:便を編集 2：このルートで便を登録 3:便を登録(増便)
    functionFlag: {type: String, default: '0'},
    // 親側インデックス
    shiftIndex:'',
    transportKind: 0
  },
  mounted () {
    console.log("stationCom mounted")
    // このルートで便を登録的场合
    if (this.functionFlag === '2' && this.shiftIndex == '0') {
      // 获取route下拉框和停留所相关信息
      // ルート詳細画面（このルートで便を登録）でセットしている
      this.routeStationInfo = JSON.parse(sessionStorage.getItem('routerInfo'))
    } else {
      // 获取route下拉框和停留所相关信息
      // 運行便一覧画面でセットしている
      this.routeStationInfo = JSON.parse(sessionStorage.getItem('routeStationInfo'))
    }
    this.chooseRoute(this.routeId)
    if (this.$route.query.isCancel === 'true' || this.$route.query.isCancel === true) {
      if (sessionStorage.getItem('shiftList') !== null) {
        let shiftList = JSON.parse(sessionStorage.getItem('shiftList'))
        let rId = shiftList[this.shiftIndex].shiftBasic.routeId
        if (rId !== '') {
          this.chooseRoute(rId)
        }
        for (let i = 0; i < shiftList[this.shiftIndex].hourList.length; i++) {
          this.$set(this.hourList, i, shiftList[this.shiftIndex].hourList[i])
          this.$emit('getHour', this.hourList, this.shiftIndex)
        }
        for (let i = 0; i < shiftList[this.shiftIndex].minuteList.length; i++) {
          this.$set(this.minuteList, i, shiftList[this.shiftIndex].minuteList[i])
          this.$emit('getMinute', this.minuteList, this.shiftIndex)
        }
      }
    }
  },
  watch: {
    routeId (value) {
      this.chooseRoute(value)
    },
    goBackFlag (value) {
      this.hourList = []
      this.minuteList = []
      this.timeValidateFlag = false
      this.startEndTimeValidateFlag = false
    },
    hourList () {
      this.watchHourMinuteValidate()
    },
    minuteList () {
      this.watchHourMinuteValidate()
    },
  },
  methods: {
    mountedFunc(){
      console.log("stationCom mountedFunc")
      // このルートで便を登録的场合
      if (this.functionFlag === '2' && this.shiftIndex == '0') {
        // 获取route下拉框和停留所相关信息
        this.routeStationInfo = JSON.parse(sessionStorage.getItem('routerInfo'))
      } else {
        // 获取route下拉框和停留所相关信息
        this.routeStationInfo = JSON.parse(sessionStorage.getItem('routeStationInfo'))
      }
      this.chooseRoute(this.routeId)
      if (this.$route.query.isCancel === 'true' || this.$route.query.isCancel === true 
        || this.$route.query.editorIsCancel === 'true' || this.$route.query.editorIsCancel === true) {
        if (sessionStorage.getItem('shiftList') !== null) {
          let shiftList = JSON.parse(sessionStorage.getItem('shiftList'))
          let rId = shiftList[this.shiftIndex].shiftBasic.routeId
          if (rId !== '') {
            this.chooseRoute(rId)
          }
          for (let i = 0; i < shiftList[this.shiftIndex].hourList.length; i++) {
            this.$set(this.hourList, i, shiftList[this.shiftIndex].hourList[i])
            this.$emit('getHour', this.hourList, this.shiftIndex)
          }
          for (let i = 0; i < shiftList[this.shiftIndex].minuteList.length; i++) {
            this.$set(this.minuteList, i, shiftList[this.shiftIndex].minuteList[i])
            this.$emit('getMinute', this.minuteList, this.shiftIndex)
          }
        }
      }
    },
    // 时间校验
    timeValidate () {
      if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
        if (this.hourList[this.selectedRouteStationInfo.length - 1] === undefined ||
          this.minuteList[this.selectedRouteStationInfo.length - 1] === undefined) {
          this.timeValidateFlag = true
          return false
        }
      } else{
        if (this.hourList[0] === undefined ||
          this.minuteList[0] === undefined) {
          this.timeValidateFlag = true
          return false
        }
      }
      return true
    },
    // 实时监控时分的校验
    watchHourMinuteValidate () {
      if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
        if (this.hourList[this.selectedRouteStationInfo.length - 1] !== undefined &&
           this.minuteList[this.selectedRouteStationInfo.length - 1] !== undefined) {
          this.timeValidateFlag = false
        }
      } else {
        if (this.hourList[0] !== undefined &&
            this.minuteList[0] !== undefined) {
          this.timeValidateFlag = false
        }
      }
    },
    // 将出发地和终着地时间校验标志位置为true，触发验证
    triggerValidate () {
      this.startEndTimeValidateFlag = true
    },
    // 选择hour
    clickHour () {
      this.$emit('getHour', this.hourList, this.shiftIndex)
    },
    // 选择hour
    clickMinute () {
      this.$emit('getMinute', this.minuteList, this.shiftIndex)
    },
    // 选择route
    chooseRoute (val) {
      console.log("chooseRoute コンポーネント内")
      if (val !== '') {
        this.selectedRouteStationInfo = []
        this.routeStationInfo.forEach(item => {
          if (item.routeId === val) {
            this.selectedRouteStationInfo.push(item)
          }
        }
        )
        // 根据経由地番号进行排序
        this.selectedRouteStationInfo.sort((a, b) => { return a.routeNo - b.routeNo })
        // 将选中的route相关的所有信息传到父组件
        this.$emit('getSelectedRouteStationInfo', this.selectedRouteStationInfo, this.shiftIndex)
        // 切换route后，时间作清空处理
        this.hourList = []
        this.minuteList = []
      }
    },
    // 時間を自動計算する
    computeValidate () {
      console.log("computeValidate")
      if (this.timeValidate()) {
        let latLngList = []
        if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
          for (let i = this.selectedRouteStationInfo.length - 1; i >= 0; i--) {
            let latLngObject = {}
            latLngObject.lat = this.selectedRouteStationInfo[i].stationLat
            latLngObject.lng = this.selectedRouteStationInfo[i].stationLng
            latLngList[this.selectedRouteStationInfo.length - 1 - i] = latLngObject
          }
        } else {
          for (let i = 0; i < this.selectedRouteStationInfo.length; i++) {
            let latLngObject = {}
            latLngObject.lat = this.selectedRouteStationInfo[i].stationLat
            latLngObject.lng = this.selectedRouteStationInfo[i].stationLng
            latLngList[i] = latLngObject
          }
        }
        PlannRoute(latLngList, false).then(response => {
          // 自动推算乘车预定时间
          if ((this.goBackFlag === '0' && this.transportKind === 0) ||(this.goBackFlag === '1' && this.transportKind === 1)) {
            // 重组数据
            let estimateHour = this.hourList[this.hourList.length - 1] < 10 ? '0' + this.hourList[this.hourList.length - 1] : this.hourList[this.hourList.length - 1]
            let estimateMinute = this.minuteList[this.minuteList.length - 1] < 10 ? '0' + this.minuteList[this.minuteList.length - 1] : this.minuteList[this.minuteList.length - 1]
            let lastEstimateTime = estimateHour + ':' + estimateMinute
            let time
            if(this.transportKind === 0){
              time = DateUtil.planTimeList(response, lastEstimateTime, this.goBackFlag)
            }else{
              // 帰り区域外
              time = DateUtil.planTimeList(response, lastEstimateTime, '0')
            }
            // 显示当前自动计算时间
              let j = 0
              for (let i = this.selectedRouteStationInfo.length - 2; i >= 0; i--) {
                this.$set(this.hourList, i, time[j].hour)
                this.$set(this.minuteList, i, time[j].min)
                j++
              }
          } else {
            let estimateHour = this.hourList[0] < 10 ? '0' + this.hourList[0] : this.hourList[0]
            let estimateMinute = this.minuteList[0] < 10 ? '0' + this.minuteList[0] : this.minuteList[0]
            let lastEstimateTime = estimateHour + ':' + estimateMinute
            let time
            if(this.transportKind === 0){
              time = DateUtil.planTimeList(response, lastEstimateTime, this.goBackFlag)
            }else{
              // 行き区域外
              time = DateUtil.planTimeList(response, lastEstimateTime, '1')
            }
            // 显示当前自动计算时间
            for (let i = 1; i < this.selectedRouteStationInfo.length; i++) {
              this.$set(this.hourList, i, time[i - 1].hour)
              this.$set(this.minuteList, i, time[i - 1].min)
            }
          }
          this.clickHour()
          this.clickMinute()
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
}
</script>

<template>
    <div class="clearfix" style="margin-top:-5px" >
      <div class="clearfix" v-for="(routeStationInfo,key) in selectedRouteStationInfo" :key="key">
        <div class="col-md-7 column paddingTop">
          <div class="row clearfix">
          <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15" style="width:22.2%">
            <div class="row clearfix">
              <div class="col-md-12 column clearfix" v-if="key===0">
                出発地
              </div>
              <div class="col-md-12 column clearfix" v-else-if="key===selectedRouteStationInfo.length-1">
                終着地
              </div>
              <div class="col-md-12 column clearfix" v-else>
                停留所{{key}}
              </div>
            </div>
            </div>
          <div class="col-md-4 column stationWidth">
            <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix">{{routeStationInfo.stationName}}</div>
          </div>
          </div>
        </div>
        <div class="col-md-5 rightDivWidth paddingTop paddingBottom" 
        :class="{bgc14:(key===0&&goBackFlag==='0'&&transportKind===1)
                      ||(key===0&&goBackFlag==='1'&&transportKind===0)
                      ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='0'&&transportKind===0)
                      ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='1'&&transportKind===1)
                      }">
          <div class="row clearfix">
          <div class="col-md-4 column divTitle shortDiv bgc8 F3-R-15" style="width:35%;margin-left:10px;">
            <div class="row clearfix">
              <div class="col-md-3 column clearfix"
                  v-if="(key===0&&goBackFlag==='0'&&transportKind===1)
                      ||(key===0&&goBackFlag==='1'&&transportKind===0)
                      ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='0'&&transportKind===0)
                      ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='1'&&transportKind===1)">
                ※
              </div>
              <div class="col-md-3 column clearfix" v-else>
              </div>
              <div class="col-md-9 column clearfix paddingLeftZero textAlignLeft" v-if="key===0">
                出発予定時間
              </div>
              <div class="col-md-9 column clearfix paddingLeftZero textAlignLeft" v-else>
                到着予定時間
              </div>
            </div>
          </div>
          <div class="col-md-3 column paddingRightZero">
            <div class="clearfix">
            <select :class="{selectstyles:true, selectImg:true}"
            :name="`selectHour${key}idx${shiftIndex}`" v-validate="{required: startEndTimeValidateFlag
                      &&((key===0&&goBackFlag==='0'&&transportKind===1)
                      ||(key===0&&goBackFlag==='1'&&transportKind===0)
                      ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='0'&&transportKind===0)
                      ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='1'&&transportKind===1))}"
            v-model="hourList[key]" @change="clickHour">
            <option v-for="n in 24" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
            </select>
            </div>
            <div class="clearfix" style="width:200px">
              <span v-if="errors.has(`selectHour${key}idx${shiftIndex}`)" class="errorMessage"> {{ errors.first(`selectHour${key}idx${shiftIndex}`) }} </span>
              <span v-else-if="errors.has(`selectMinute${key}idx${shiftIndex}`)" class="errorMessage"> {{ errors.first(`selectMinute${key}idx${shiftIndex}`) }} </span>
              <span v-else-if="(transportKind == 0)&&((key===0&&goBackFlag==='1')||(key===selectedRouteStationInfo.length-1&&goBackFlag==='0'))&&timeValidateFlag" class="errorMessage">
                  必須入力項目が未入力です。
              </span>
              <span v-else-if="(transportKind == 1)&&((key===selectedRouteStationInfo.length-1&&goBackFlag==='1')||(key===0&&goBackFlag==='0'))&&timeValidateFlag" class="errorMessage">
                  必須入力項目が未入力です。
              </span>
            </div>
          </div>
          <div class="col-md-1 column aloneWordDiv timeWidth F3-R-17">
            時
          </div>
          <div class="col-md-3 column paddingLeftZero">
            <select
              :class="{selectstyles:true, selectImg:true}"
              :name="`selectMinute${key}idx${shiftIndex}`"
              v-validate="{required: ((key===0&&goBackFlag==='0'&&transportKind===1)
                                    ||(key===0&&goBackFlag==='1'&&transportKind===0)
                                    ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='0'&&transportKind===0)
                                    ||(key===selectedRouteStationInfo.length-1&&goBackFlag==='1'&&transportKind===1))}"
              v-model="minuteList[key]" @change="clickMinute">
            <option v-for="n in 60" :key="n" :value="n-1">{{n-1>9?n-1:"0"+(n-1)}}</option>
            </select>
          </div>
          <div class="col-md-1 column aloneWordDiv timeWidth F3-R-17" style="margin-left: -15px;">
            分
          </div>
          </div>
        </div>
      </div>
      <div class="clearfix" v-if="selectedRouteStationInfo.length > 0 && timeError === true">
        <div class="col-md-7 column">
        </div>
        <div class="col-md-5 column errorMessage paddingTop paddingBottom rightDivWidth">
          入力時間の順序が不正です。
        </div>
      </div>
      <div class="clearfix" v-if="selectedRouteStationInfo.length > 0 && shiftTimeError === true">
        <div class="col-md-7 column">
        </div>
        <div class="col-md-5 column errorMessage paddingTop paddingBottom rightDivWidth">
          未入力の項目があります。
        </div>
      </div>
      <div class="clearfix"  v-if="selectedRouteStationInfo.length > 0">
        <div class="col-md-7 column">
        </div>
        <div class="col-md-5 column rightDivWidth paddingTop bgc15" style="height: 92px; z-index: 2;">
          <div class="row clearfix">
          <button class="T7-radius F2-R" @click="computeValidate">
          時間を自動計算する
          </button>
          </div>
          <div class="row clearfix F2-R" style="margin-top:5px">
            <div class="col-md-1 column clearfix paddingRightZero">
              ※
            </div>
            <div class="col-md-11 column clearfix textAlignLeft paddingLeftZero">
              赤枠の時刻を入力した後、「時間を自動計算する」ボタンを押してください
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<style scoped>
.divTitle {
  height: 50px;
  line-height: 50px;
}
.T7-radius {
  width: 100%;
  max-width: 250px;
  height: 40px;
  background: linear-gradient(#888886 50%, #696a65 50%) !important;
  border-radius: 30px;
  text-align: center;
  padding: 0;
  border: 0;
}
.selectstyles {
  border: solid 1px #ccc;
  border-radius: 10px;
  width: 100%;
  height: 50px;
  line-height: 20px;
  font-size: 16px;
  text-align: left;
  padding-left: 12px;
  background-color: white !important;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../assets/dropselect.png") no-repeat scroll right center transparent;
}
.longsolid {
  padding: 0px 12px;
  text-align: left;
}
.textAlignLeft {
  text-align: left;
}
.paddingLeftZero {
  padding-left: 0px;
}
.paddingRightZero {
  padding-right: 0px;
}
.stationWidth {
  width: 77%;
}
.shortDiv {
  width: 13%;
  min-width: 120px;
}
.divMarginTop {
  margin-top: 10px;
}
.errorMessage {
  color: red;
}
.aloneWordDiv{
  display:flex;
  align-items:center;
  justify-content:center;
  height:50px;
  padding-left: 0px;
  padding-right: 0px;
}
.rightDivWidth{
  width:37%;
}
.paddingTop{
  padding-top: 5px;
}
.paddingBottom{
  padding-bottom: 5px;
}
.timeWidth{
  width: 7%;
}
</style>



// WEBPACK FOOTER //
// src/components/StationInfoComponent.vue